import { render, staticRenderFns } from "./PharmaceuticalForms.vue?vue&type=template&id=24ea45d0"
import script from "./PharmaceuticalForms.vue?vue&type=script&lang=js"
export * from "./PharmaceuticalForms.vue?vue&type=script&lang=js"
import style0 from "./PharmaceuticalForms.vue?vue&type=style&index=0&id=24ea45d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports